import { Command } from "./index";
import { Icon } from "@chakra-ui/react";
import { MdCircle } from "react-icons/md";
import { insertSurroundingText } from "../utils/insertSurroundingText";
import { convertGameMakerColourToHex } from "../../../utils/convertGameMakerColourToHex";

export const colourOrange: Command = {
  category: "colour",
  icon: <Icon as={MdCircle} />,
  name: `#${convertGameMakerColourToHex(4235519)}`,
  tooltip: "colour as orange",
  execute: (editorRef) => insertSurroundingText(editorRef, "{{#colourOrange}}", "{{/colourOrange}}"),
};
